var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4709 42L18.358 28.875L22.0296 25.0687L28.8483 31.8937V10.5H34.0935V31.8937L40.9122 25.0687L44.5838 28.875L31.4709 42ZM15.7354 52.5C14.293 52.5 13.0586 51.9864 12.0323 50.9591C11.006 49.9319 10.492 48.6955 10.4902 47.25V39.375H15.7354V47.25H47.2064V39.375H52.4515V47.25C52.4515 48.6937 51.9384 49.9301 50.9121 50.9591C49.8858 51.9881 48.6505 52.5017 47.2064 52.5H15.7354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSymbol);
export default __webpack_public_path__ + "static/media/download_symbol.17decd629a1664554604b9e9a6d1f5b9.svg";
export { ForwardRef as ReactComponent };